/**
 * 画面上部にMTデフォルトの形式のメッセージを表示します。
 *
 * Updated: 2023/09/28
 *
 * @param {Object} options
 * @param {String} options.msg - 表示するメッセージ
 * @param {String} [options.type='info'] - メッセージのタイプ: 'success', 'info', 'warning', or 'danger'
 * @param {Boolean} [options.dismissible=false] - trueをセットすると閉じるボタンを表示します。
 * @param {Boolean} [options.noInsert=false] - trueをセットするとページに表示せずにHTMLだけを返します。
 *
 * @returns {String|undefined} - noInsertがtrueの場合、メッセージのHTMLを返します。
 *
 * @example
 * mtapp.msg({ msg: 'データを保存しました。<a href="#">データを見る。</a>', type: 'success', dismissible: true });
 */
// TODO https://movabletype.atlassian.net/browse/FEEDBACK-2460 によりクラス名を調整
//  alert-dismissable => alert-dismissible
//  close => btn-close
//  close > span => remove
export function msg(options) {
    const defaults = {
        msg: '',
        type: 'info',
        dismissible: false,
        noInsert: false
    };
    const op = { ...defaults, ...options };

    let msgHtml = `<div class="alert alert-${op.type}" role="alert">${op.msg}</div>`;
    if (op.dismissible) {
        msgHtml = `
            <div class="alert alert-${op.type} alert-dismissable fade show" role="alert">
                ${op.msg}
                <button type="button" class="close" data-bs-dismiss="alert" aria-label="Close">
                    <span aria-hidden="true">×</span>
                </button>
            </div>`;
    }

    if (op.noInsert) {
        return msgHtml.replace(/[\n\r]+\s*/g, '');
    }

    const msgBlock = document.getElementById('msg-block');
    const msgContainer = document.getElementById('msg-container');
    const mainContentHeader = document.querySelector('.mt-main_content_header');
    const mainWidgetContainer = document.getElementById('main-widget-container');

    const newElement = document.createElement('div');
    newElement.innerHTML = msgHtml.trim();
    if (msgBlock) {
        msgBlock.appendChild(newElement.firstChild);
    } else if (msgContainer) {
        msgContainer.appendChild(newElement.firstChild);
    } else if (mainContentHeader) {
        mainContentHeader.parentNode.insertBefore(newElement.firstChild, mainContentHeader.nextSibling);
    } else if (mainWidgetContainer) {
        mainWidgetContainer.parentNode.insertBefore(newElement.firstChild, mainWidgetContainer);
    } else {
        const pageTitle = document.getElementById('page-title');
        pageTitle.parentNode.insertBefore(newElement.firstChild, pageTitle.nextSibling);
    }
}
